import React from 'react';

/**
 * Taken from connectAdvanced.js in react-redux.
 */
export default function componentName(component: React.ComponentType<{}>): string {
  return component.displayName || component.name || 'Component';
}
